/**
 * Mixin metod
 * Zawiera metody:
 *  - `deepClone(src)` - Klonuje obiekt
 */
export const methodsMixin = {
  methods: {
    /**
     * Klonuje obiekt
     *
     * @param {*} src
     */
    deepClone(src) {
      return JSON.parse(JSON.stringify(src));
    }
  }
};
